import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as dimensionFilter from '../dimension-filter'

export const FILTER_INPUT = graphql.transformers.IN.object<
  ents.extra.space.Report.Configuration.DataExport.Filter,
  graphql.schema.SpaceReportDataExportFilterInput
>(
  {
    clusterFilter: dimensionFilter.TRANSFORMER,
    organizationFilter: dimensionFilter.TRANSFORMER,
    spaceFilter: dimensionFilter.TRANSFORMER,
  },
  { onNullish: 'remove' },
)

export const LAYOUT = graphql.transformers.IN.enumeration<
  ents.extra.space.Report.Configuration.DataExport.Layout,
  graphql.schema.SpaceReportDataExportLayout
>({
  [ents.extra.space.Report.Configuration.DataExport.Layout.Rows]:
    graphql.schema.SpaceReportDataExportLayout.Rows,
  [ents.extra.space.Report.Configuration.DataExport.Layout.Columns]:
    graphql.schema.SpaceReportDataExportLayout.Columns,
})

export const CONFIGURATION_INPUT = graphql.transformers.IN.object<
  ents.extra.space.Report.Configuration.DataExport,
  graphql.schema.SpaceReportDataExportConfigurationInput
>({
  accountFields: graphql.transformers.IN.list(transformers.PASS_THROUGH),
  accountLayout: LAYOUT,
  fields: graphql.transformers.IN.list(transformers.PASS_THROUGH),
  filter: graphql.transformers.IN.nonNull(FILTER_INPUT),
  functionalUsageFields: graphql.transformers.IN.list(
    transformers.PASS_THROUGH,
  ),
  functionalUsageLayout: LAYOUT,
  occupantFields: graphql.transformers.IN.list(transformers.PASS_THROUGH),
  occupantLayout: LAYOUT,
  responsiblePersonFields: graphql.transformers.IN.list(
    transformers.PASS_THROUGH,
  ),
  responsiblePersonLayout: LAYOUT,
})
